module.exports = __webpack_public_path__ + "static/meepdevsbattlesimulator-4bed59a9db8de6931dec4a2009407ba3.png";